import apiService from 'apiService'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'

// components

export default function CardEditStore() {
    const { id } = useParams()
    const [name, setName] = useState('')
    const [ipAddress, setIpAddress] = useState('')
    const [hardwareKey, setHardwareKey] = useState('')

    const handleNameChange = e => setName(e.target.value)
    const handleHardwareKeyChange = e => setHardwareKey(e.target.value)
    const handleIpAddressChange = e => setIpAddress(e.target.value)

    const getStoreInfo = async () => {
        const response = await apiService.get(`/stores/${id}`)
        const { hardware_key, ip_address, name } = response
        setHardwareKey(hardware_key)
        setIpAddress(ip_address)
        setName(name)
    }

    const handleEditStore = async () => {
        const payload = {
            name: name,
            ip_address: ipAddress,
            hardware_key: hardwareKey
        }

        const response = await apiService.put(`/stores/${id}`, payload)
        if (response === null) return
        toast.success('Επιτυχής επεξεργασία καταστήματος!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
    }

    useEffect(() => {
        getStoreInfo()
    }, [])

    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold">Επεξεργασία Καταστήματος</h6>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                    <form>
                        <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase"></h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12 px-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΟΝΟΜΑ ΚΑΤΑΣΤΗΜΑΤΟΣ</label>
                                    <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Όνομα Καταστήματος" value={name} onChange={handleNameChange} />
                                </div>
                            </div>
                            <div className="w-full lg:w-12 px-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Hardware Key</label>
                                    <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Hardware Key" value={hardwareKey} onChange={handleHardwareKeyChange} />
                                </div>
                            </div>
                            <div className="w-full lg:w-12 px-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">IP ADDRESS</label>
                                    <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="IP Address" value={ipAddress} onChange={handleIpAddressChange} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold"></h6>
                        <button className="bg-orange-500 text-white active:bg-orange-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" onClick={handleEditStore}>
                            Επεξεργασια καταστηματος
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
